import React, { useState, forwardRef, useEffect, useRef, useImperativeHandle } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";
import MeaButton from "../../../../components/MeaButton";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

const UpdateStudentResultObservationModal = forwardRef((props, ref) => {
  //
  const [message, setMessage] = useState("");
  //
  useEffect(() => {
    setMessage(props?.student?.result_observation);
  }, [props?.student?.result_observation]);
  //
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  //
  const [loading, setLoading] = useState(false);
  //
  const toast = useRef(null);
  //
  const handleUpdateSubmit = async (e) => {
    // Handle update action
    setLoading(true);
    studentsAPI.UpdateResult(props.schoolId, props.trainingId, "", props.student?.id, null, message).then(() => {
      toast.current.show({
        severity: "success",
        summary: "Succès",
        life: 1000,
        detail: "Modification effectuée avec succès!",
      });
      setActive(false);
      callbackFn?.();
    }).catch((err) => {
      toast.current.show({
        severity: "error",
        summary: "Erreur",
        detail: "Erreur de modification!",
      });
    }).finally(() => {
      setLoading(false);
    });
  };

  //
  useImperativeHandle(ref, () => ({
    show: (callback) => {
      setCallbackFn(() => callback);
      setActive(true);
    },
    hide: () => {
      setActive(false);
    }
  }));
  const footerContent = (
    <div className="flex justify-content-between">
      <div>
      </div>
      <div></div>
      <div>
        <MeaButton
          label="Annuler"
          icon="pi pi-times"
          disabled={loading}
          onClick={() => setActive(false)}
          className="p-button-text"
        />
        <MeaButton
          type="submit"
          loading={loading}
          label="Enregistrer"
          icon="pi pi-save"
          onClick={() => handleUpdateSubmit()}
        />
      </div>
    </div>
  );

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        focusOnShow={false}
        header="Suivi / Appréciation générale"
        visible={active}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <div className="w-full">
          <div className="flex flex-column gap-2">
            <label htmlFor="delay" className="block text-900 font-medium mb-2">
              Appréciation générale
            </label>
            <InputTextarea
              id="delay"
              autoFocus={true}
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={3}
              className="w-full mb-3"
            />
          </div>
        </div>
      </Dialog>
    </>



  );
});

export default UpdateStudentResultObservationModal;
